import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@teem/core/core.module';

import { ZatcaPhaseTwoRoutingModule } from '@teem/zatca-phase-two-module/zatca-phase-two-routing.module';
import { GenerateCertificateComponent } from '@teem/zatca-phase-two-module/components/generate-certificate/generate-certificate.component';
import { ZatcaPhaseTwoComponent } from '@teem/zatca-phase-two-module/zatca-phase-two.component';
import { OtpModalComponent } from '@teem/zatca-phase-two-module/modals/otp-modal/otp-modal.component';

@NgModule({
  declarations: [
    GenerateCertificateComponent,
    ZatcaPhaseTwoComponent,
    OtpModalComponent
  ],
  entryComponents: [
    OtpModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    ZatcaPhaseTwoRoutingModule
  ],
})
export class ZatcaPhaseTwoModule { }
